const indexData = [
  { title: '2026暑期档精选', count: '86部', tag: '热门', color: 'accent' },
  { title: '豆瓣高分TOP100', count: '100部', tag: '经典', color: 'primary' },
  { title: '华语院线大片', count: '352部', tag: '最新', color: 'accent' },
  { title: '好莱坞动作巨制', count: '218部', tag: '刺激', color: 'primary' },
  { title: '日韩影视精选', count: '165部', tag: '热播', color: 'accent' },
  { title: '悬疑烧脑合集', count: '143部', tag: '高能', color: 'primary' },
  { title: '爆笑喜剧专场', count: '197部', tag: '欢乐', color: 'accent' },
  { title: '纪录与人文', count: '89部', tag: '深度', color: 'primary' },
  { title: '动画亲子乐园', count: '124部', tag: '合家欢', color: 'accent' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-2 h-6 md:h-7 rounded-full bg-primary-500"></span>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">专题合集</h2>
        </div>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10">按类型与主题精心整理的影片合集，快速找到你的观影方向</p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexData.map((item, i) => (
            <a
              key={i}
              href="#index"
              className="group p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/40 hover:border-primary-500/30 transition-all cursor-pointer"
            >
              <div className="flex items-start justify-between mb-3">
                <span
                  className={`w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl ${
                    item.color === 'accent' ? 'bg-accent-500/15' : 'bg-primary-500/15'
                  }`}
                >
                  <i
                    className={`${
                      item.color === 'accent' ? 'ri-movie-2-line text-accent-400' : 'ri-film-line text-primary-400'
                    } text-lg`}
                  ></i>
                </span>
                <span
                  className={`px-2 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
                    item.color === 'accent'
                      ? 'bg-accent-500/15 text-accent-400'
                      : 'bg-primary-500/15 text-primary-400'
                  }`}
                >
                  {item.tag}
                </span>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-50 group-hover:text-primary-400 transition-colors mb-1">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-400">{item.count} 影片</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}